import { Grid } from "@nextui-org/react"

import { Content } from "../../ui/layout/content"
import HeaderText from "../../ui/header"
import Tile from "../../ui/tile"
import ConnectIcon from '../../ui/resources/GL_connect.png'
import SupportIcon from '../../ui/resources/GL_support.png'
import ManageIcon from '../../ui/resources/GL_manage.png'

export default () => {
    return (
        <>
            <Content spacerSize={2}>
                <Grid.Container gap={2} justify="center">
                    <Grid xs={12} sm={4}>
                        <Tile 
                            // centered={true}
                            bordered={true}
                            header="Dedication"
                            // icon={ConnectIcon}
                            text="We handhold you through the whole engagement and collaboration process every step of the way. "/>
                    </Grid>
                    <Grid xs={12} sm={4}>
                        <Tile 
                            // centered={true}
                            bordered={true}
                            header="Expertise"
                            // icon={ConnectIcon}
                            text="We provide expertise in insurance applications, legal, privacy and IP suggestions to ensure the collaboration is set up for success."/>
                    </Grid>
                    <Grid xs={12} sm={4}>
                        <Tile 
                            // centered={true}
                            bordered={true}
                            header="Services"
                            // icon={SupportIcon}
                            text="We connect you to reliable and affordable service providers such as R&D tax and software development."/>
                    </Grid>
                    <Grid xs={12} sm={4}>
                        <Tile 
                            // centered={true}
                            bordered={true}
                            header="Ecosystem"
                            // icon={ConnectIcon}
                            text="We establish connections for you to VC/angel investors as well as other like minded companies to grow your network."/>
                    </Grid>
                    <Grid xs={12} sm={4}>
                        <Tile 
                            // centered={true}
                            bordered={true}
                            header="Expansion"
                            // icon={ConnectIcon}
                            text="We provide you the pathway to funding and opportunity to land your business in tech hubs in Asia."/>
                    </Grid>
                </Grid.Container>
            </Content>
        </>
    )
}